/**
 * 全站权限配置
 *
 */
import router from './router/router'
import store from '@/store'
import validate from '@/util/validate'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
import menuService from "@/api/menu";


NProgress.configure({showSpinner: false});
const lockPage = store.getters.website.lockPage; // 锁屏页

/**
 * 导航守卫，相关内容可以参考:
 * https://router.vuejs.org/zh/guide/advanced/navigation-guards.html
 */
router.beforeEach((to, from, next) => {
  // 缓冲设置
  if (to.meta.keepAlive === true && store.state.tags.tagList.some(ele => {
    return ele.value === to.fullPath
  })) {
    to.meta.$keepAlive = true
  } else {
    NProgress.start();
    if (to.meta.keepAlive === true && validate.checkNull(to.meta.$keepAlive)) {
      to.meta.$keepAlive = true
    } else {
      to.meta.$keepAlive = true
    }
  }
  const meta = to.meta || {};
  let addTag = function () {
    const value = to.query.src || to.fullPath;
    const label = to.query.label || to.query.name || to.name;
    if (meta.isTab !== false && !validate.checkNull(value) && !validate.checkNull(label)) {
      store.commit('ADD_TAG', {
        label: label,
        value: value,
        params: to.params,
        query: to.query,
        group: router.$avueRouter.group || []
      })
    }
  };
  //钉钉进入
  if (dd.env.platform!="notInDingTalk") {
    dd.ready(function () {
      dd.runtime.permission.requestAuthCode({
        corpId: 'dingfcdb0781e84c52c135c2f4657eb6378f', // 企业id
        onSuccess: function (info) {
            menuService.dingtalkLogin({code:info.code}).then((result) => {
              let url = sessionStorage.processIsApproved_url?sessionStorage.processIsApproved_url:window.location.href
              let id = validate.GetQueryString(url,'id');
              let value = validate.GetQueryString(url,'value')
              // 1-客户审批；2-合同启动审批；3-合同关闭审批；4-合同结案审批；5-合同开票审批；6-合同附件盖章审批；7-框架协议盖章审批；8-品牌审批；9-品牌供应商审批；10-品牌合同启动审批；11-品牌合同结案审批；12-品牌合同盖章审批；13-品牌合同开票审批；14-外附合同盖章审批；15-商务供应商审批
              let typeList = [
                {name:'addApproval',id:8},
                {name:'contractStart',id:10},
                {name:'contractCase',id:11},
                {name:'contractSeal',id:12},
                {name:'contractInvoice',id:13},
                {name:'outsideContract',id:14},
                {name:'contractSupplier',id:9},
                {name:'contract-start',id:2},
                {name:'contract-end',id:4},
                {name:'contract-close',id:3},
                {name:'custom',id:1},
                {name:'invoice',id:5},
                {name:'sealed',id:7},
                {name:'examination',id:6},
                {name:'businessApproval',id:15},
              ]
              //遍历类型
              let type = ''
              for (let i = 0; i < typeList.length; i++) {
                if(value && value == typeList[i].name){
                  type = typeList[i].id
                }else{
                  if(url.indexOf(`${typeList[i].name}`) != -1){
                    type = typeList[i].id
                  }
                }
              }
              if(id){
                //存入本地防止一直刷新获取不到值
                sessionStorage.setItem("processIsApproved_url",url)
                console.log('=====AAAAAAdididididi======',url)
              }
              console.log('======审批信息======',url,id,type)
              //查询是否审批通过
              menuService.processIsApproved({id,type}).then((res) => {
                console.log('=======进入页面=======',res.data)
                if(res.data == true){
                  // store.state.common.isSuccessView = 1;
                  store.commit("SET_ISVIEW",1)
                  next();
                  addTag();
                  router.onError((error) => {
                    const pattern = /Loading chunk views failed/g;
                    const isChunkLoadFailed = error.message.match(pattern);
                    const targetPath = router.history.pending.fullPath;
                    if (isChunkLoadFailed) {
                      // window.location.reload();
                      router.replace(targetPath);
                    }
                  });
                }else{
                  // store.state.common.isSuccessView = 2;
                  store.commit("SET_ISVIEW",2)
                  next();
                  addTag();
                  router.onError((error) => {
                    const pattern = /Loading chunk views failed/g;
                    const isChunkLoadFailed = error.message.match(pattern);
                    const targetPath = router.history.pending.fullPath;
                    if (isChunkLoadFailed) {
                      // window.location.reload();
                      router.replace(targetPath);
                    }
                  });
                }
              })
              console.log('=====地址=======',window.location.href)
            }).catch((err) => {
              console.log('=====接口失败=====',err)
            });
        },
      });
    });
    return
  }
  if (!(to.path === '/login')) {
    if (validate.checkNull(store.getters.user)) {
      store.dispatch('getUser').then(() => {
        if (validate.checkNotNull(store.getters.user)) {
          if (to.path === '/login') {
            next({path: '/'})
          } else {
            addTag();
            next()
          }
        } else {
          if (meta.isAuth === false) {
            addTag();
            next()
          } else {
            next('/login')
          }
        }
      }).catch((e) => {
        store.dispatch('fedLogOut').then(() => {
          next({path: '/login'})
        })
      })
    } else {
      addTag();
      next()
    }
  } else {
    if (validate.checkNull(store.getters.user)) {
      addTag();
      next()
    } else {
      next({path: '/'})
    }
  }

});


router.afterEach(() => {
  NProgress.done();
  const title = store.getters.tag.label;
  router.$avueRouter.setTitle(title)
});
